import Table from 'src/javascripts/components/Table';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import * as filestack from 'filestack-js';
import * as fileUpload from 'blueimp-file-upload/js/jquery.fileupload.js';

export default class SurveysApprovalRequestsIndex {

  constructor() {}

  render() {

    // Render table
    if ( $('#survey_approval_requests_table_wrapper').length === 0 ) {
      let table = new Table($('#survey_approval_requests_table'));
      $.when( table.render() ).then( status => table.setUp('survey_approval_requests_table') )
    }

  }

}